import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "micro_user",
  "use": "micro_user-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 10\" id=\"micro_user\"><path d=\"M1 6h8v2L8 9H2L1 8z\" opacity=\".1\" /><path d=\"M5 0a5 5 0 1 1 0 10A5 5 0 0 1 5 0Zm0 6a3.744 3.744 0 0 0-3 1.5C2.684 8.41 3.773 9 5 9a3.744 3.744 0 0 0 3-1.5A3.744 3.744 0 0 0 5 6Zm0-4.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol